import { exec } from 'node:child_process'

const escapeCliArg = (url: string) => {
  return url.replace(/([&])/g, '\\$1') // Escape `&` with a backslash
}

export const openBrowser = (url: string) => {
  // Don't open the browser when running integration tests
  if (process.env.NODE_ENV === 'INTEGRATION') return

  const escapedUrl = escapeCliArg(url)

  switch (process.platform) {
    case 'darwin':
      exec(`open ${escapedUrl}`)
      break
    case 'win32':
      exec(`start ${escapedUrl}`)
      break
    case 'linux':
      exec(`xdg-open ${escapedUrl}`)
      break
  }
}
